<template>
  <div class="w-full p-8 gap-4 flex flex-col bg-[#F1F1F1]">
    <div
      ref="header"
      class="w-full gap-2 flex flex-col items-center justify-center text-center"
    >
      <span class="text-3xl font-bold text-gray-900">{{
        $t('auth.registration.title')
      }}</span>
      <!-- <span class="text-[#7C7C7C] leading-5">
        Для створення акаунта введи ім'я та електронну пошту
      </span> -->
    </div>

    <BaseForm ref="form" class="mt-4 gap-4 flex flex-col">
      <BaseFormField
        :value="form.name"
        :rules="[$rules.required, v => $rules.counter(v, 50)]"
      >
        <template #default="{ errors }">
          <BaseInput
            v-model="form.name"
            icon="user"
            :placeholder="$t('auth.registration.namePlaceholder')"
            :errors="errors"
          />
        </template>
      </BaseFormField>

      <BaseFormField
        :value="form.email"
        :rules="[$rules.required, $rules.email, v => $rules.counter(v, 50)]"
      >
        <template #default="{ errors }">
          <BaseInput
            v-model="form.email"
            type="email"
            icon="at"
            :placeholder="$t('auth.registration.emailPlaceholder')"
            :errors="errors"
          />
        </template>
      </BaseFormField>

      <span v-if="error" class="text-error text-center">
        {{ error.message }}
      </span>
    </BaseForm>

    <BaseButton class="mx-auto" :is-loading="isLoading" @click="handleSubmit">
      {{ $t('auth.registration.register') }}
    </BaseButton>

    <div class="gap-4 flex flex-col">
      <BaseButton
        class="mx-auto"
        color="transparent"
        size="small"
        @click="handleLogin"
      >
        {{ $t('auth.registration.alreadyHaveAccount') }}
      </BaseButton>

      <div class="relative my-4 flex items-center justify-center">
        <span class="absolute px-2 text-sm text-[#999] bg-[#F1F1F1]">{{
          $t('auth.registration.or')
        }}</span>
        <div class="w-full h-px bg-[#D1D1D1]"></div>
      </div>

      <BaseButton
        class="w-full"
        variant="secondary"
        :is-disabled="isLoading"
        :is-loading="isLoadingGoogle"
        @click="$emit('google-sign-in')"
      >
        <div class="gap-4 flex items-center justify-center">
          <img src="/icons/google-logo.png" alt="Google" class="w-6 h-6" />
          {{ $t('auth.registration.loginWithGoogle') }}
        </div>
      </BaseButton>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import * as services from '@/services'

import BaseForm from '@/components/Base/BaseForm/BaseForm.vue'
import BaseFormField from '@/components/Base/BaseForm/BaseFormField.vue'
import BaseInput from '@/components/Base/BaseInput.vue'
import BaseButton from '@/components/Base/BaseButton.vue'

export default {
  name: 'AuthRegistration',

  components: { BaseForm, BaseFormField, BaseInput, BaseButton },

  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
    isLoadingGoogle: {
      type: Boolean,
      default: false
    },
    error: {
      type: Object,
      default: null
    }
  },

  data: () => ({
    form: {
      name: '',
      email: ''
    }
  }),

  computed: {
    ...mapGetters('locale', ['currentLocale'])
  },

  created() {
    if (this.$route.query?.email) {
      this.form.email = this.$route.query.email
      this.$router.replace({ query: { email: undefined } })
    }
  },

  methods: {
    handleLogin() {
      this.$emit('open-login')
    },

    async handleSubmit() {
      this.$gtag.event('auth_registration_submitted')
      const isValid = this.defineIsValid()

      if (!isValid) return

      this.$emit('update:isLoading', true)
      const { isSuccess } = await services.auth.generateOtp({
        name: this.form.name,
        email: this.form.email,
        locale: this.currentLocale
      })
      this.$emit('update:isLoading', false)

      if (!isSuccess) return

      this.$gtag.event('auth_registration_success')
      this.$emit('open-code', { email: this.form.email })
    },

    defineIsValid() {
      return this.$refs.form.defineIsValid()
    }
  }
}
</script>
